import { render, staticRenderFns } from "./UIFilterGroup.vue?vue&type=template&id=82422174"
import script from "./UIFilterGroup.vue?vue&type=script&lang=ts"
export * from "./UIFilterGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,UIFilterCheckbox: require('/app/components/Common/UI2/Filter/UIFilterCheckbox.vue').default,UIRangeSlider: require('/app/components/Common/UI2/Filter/UIRangeSlider.vue').default})
